const searchBestsellersRequests = new Map();
function loadSearchBestsellers(limit = 8) {
  if (!searchBestsellersRequests.has(limit)) {
    const root = window.Shopify?.routes?.root || '/';
    const request = fetch(root + 'collections/all?sort_by=best-selling&view=search-bestsellers-' + limit)
      .then(response => {
        if (!response.ok) throw new Error('Bestsellers unavailable');
        return response.text();
      }).catch(error => {
        searchBestsellersRequests.delete(limit);
        throw error;
      });
    searchBestsellersRequests.set(limit, request);
  }
  return searchBestsellersRequests.get(limit);
}
class SearchBestsellers extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    this.dataset.loaded = 'true';
    this.style.display = 'block';
    this.style.width = '100%';
    this.style.minWidth = '0';
    this.load();
  }
  async load() {
    try {
      const limit = this.dataset.limit === '4' ? 4 : 8;
      const html = await loadSearchBestsellers(limit);
      if (!this.isConnected) return;
      const template = document.createElement('template');
      template.innerHTML = html;
      const section = template.content.querySelector('[data-testid="product-list"]')?.closest('.shopify-section');
      if (!section || !section.querySelector('product-card')) throw new Error('Bestsellers missing');
      this.replaceChildren(section);
    } catch {
      delete this.dataset.loaded;
    }
  }
}
customElements.define('search-bestsellers', SearchBestsellers);
